module.exports = __webpack_public_path__ + "static/zakopane-034b3e9898403d8666721e5acae8e68e.png";